// @flow
import { createSelector } from "reselect"
import fp from "lodash/fp"
import type Passenger from "@kiwicom/frontend-app/scripts/containers/mutable/Passenger"
import { isInsuranceAllowedForNationality } from "@kiwicom/frontend-app/scripts/tools/insurance"

import { bookingPassengersSelector } from "mmb/scenes/AccountBooking/components/Booking/services/selector"
import { INSURANCE_NAMES } from "common/consts/insurance"

type insuranceEligiblePassengerSelectorType = (state: any) => Array<?Passenger>

const isEligibleByNationality = fp.compose(
  isInsuranceAllowedForNationality,
  fp.get("nationality"),
)

export const insuranceEligiblePassengersSelector: insuranceEligiblePassengerSelectorType = createSelector(
  bookingPassengersSelector,
  passengers =>
    passengers.filter(
      pax => isEligibleByNationality(pax) || pax.insurance !== INSURANCE_NAMES.NONE,
    ),
)
